<template>
  <section class="section">
    <div class="container">
      <h6 class="title is-6 is-uppercase has-text-left">CÁPSULAS EDUCATIVAS</h6>
      <admin-resume-table
        class="box"
        @create="showModal = true"
        @edit="editCapsule"
        @delete="confirmDelete"
        @update="saveCapsule"
        :content="capsules"
        :language="filterLanguage"
      >
        <template  v-slot:action-buttons="slotProps" >
          <a class="button is-outlined" :class="{'is-secondary':slotProps.element.featured}" @click="featureItem(slotProps.element)">
            <span class="icon is-small">
              <i class="fas fa-star"></i>
            </span>
          </a>
        </template>
      </admin-resume-table>
    </div>
    <admin-modal-creation
      :title="$t('Admin.capsules')"
      v-if="showModal"
      :show.sync="showModal"
      :values="selectedCapsule"
      @save="saveCapsule"
      :form="form"
      :language="filterLanguage"
    />
  </section>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { languageManager } from '@/mixins/LanguageManager'
import AdminResumeTable from '@/components/AdminResumeTable'
import AdminModalCreation from '@/components/AdminModalCreation'
import { fetchItems, createItem, updateItem } from '@/services/API'
import axios from 'axios'
export default {
  name: 'capsules-table',
  components: {
    AdminResumeTable,
    AdminModalCreation
  },
  mixins: [languageManager],
  data () {
    return {
      filterLanguage: this.$store.getters.activeLanguage,
      showModal: false,
      form: {},
      selectedCapsule: {},
      capsules: []
    }
  },
  mounted () {
    this.fetchCapsules()
    axios.get(`api/V2/forms/get/msteam-capsule`).then(rslt => {
      this.form = rslt.data
    })
  },
  computed: {
    ...mapState({
      isLoadingCapsules: state => state.Api.pending.capsules,
      isLoadingForm: state => state.Api.pending.form,
      errorLoadingForm: state => state.Api.error.form
    })
  },
  methods: {
    ...mapActions(['deleteCapsule']),
    featureItem (item) {
      item.featured = !item.featured
      this.saveCapsule(item)
    },
    fetchCapsules () {
      fetchItems('projects')
        .then(rslt => {
          this.capsules = rslt.data
        })
        .catch(() => {})
    },
    editCapsule (values) {
      this.selectedCapsule = values
      this.showModal = true
    },
    saveCapsule (data) {
      var action
      if (data._id) {
        action = updateItem('projects', data._id, data)
      } else {
        action = createItem('projects', data)
      }
      action
        .then(result => {
          this.fetchCapsules()
          this.showModal = false
        })
        .catch(() => {
        })
        .finally(() => {
        })
    },
    confirmDelete: function (id) {
      var self = this
      let obj = {
        title: 'Acció destructiva!',
        message: 'Si us plau confirma que vols eliminar el contingut',
        type: 'warning',
        customConfirmBtnText: 'Esborrar',
        customConfirmBtnClass: 'button is-danger',
        customCloseBtnText: 'Cancel.lar',
        customCloseBtnClass: 'button is-info',
        useConfirmBtn: true,
        onConfirm: function () {
          self.deleteCapsule({ data: { id } }).then(self.fetchCapsules)
        }
      }
      this.$Simplert.open(obj)
    }
  }
}
</script>

<style>
</style>
